import styled from "styled-components";







export const HeaderStyled = styled.header`
  width: 100%;
  height: 70vh;
  background-image: url(${props => props.theme.backgroundImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;


  @media screen and (max-width: 720px) {
    height: 60vh;
  }


`





export const Theme = styled.div`

text-align: center;
position: absolute;
top: 20%;
right: 2%;



label{
  display: block;
  margin-bottom: 10px;
  color: white;
}

span{
 
  display: block;
  
  img{
  height: 30px;
  margin: 5px;
}
}

input{
  height: 30px;
  width: 30px;
  cursor: pointer;
   transform: rotate(270deg);

}




  


`



export const Nav = styled.div`
background-color: rgba(0, 0, 0, 0.400);
  width: 100%;
  height: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

ul{

  text-align: center;

}



`


export const Icon = styled.a`
 
 li {padding: 30px;
  margin-left: 10px;
  margin-right: 10px;
  list-style: none;
  display: inline-block;


  @media screen and (max-width: 720px) {
    padding: 20px;
    margin-left: 0px;
    margin-right: 0px;
  }


}


  li::before {
  content: "";
  display: inline-block;
  background-size: cover;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  margin-bottom: -10px;
  background: url(${props => props.url}) center no-repeat;
 }



`

export const Description = styled.div`
padding: 80px;


button {
  background-color: ${props => props.theme.siteColor};
  padding: 10px;
  border-radius: 20px;
  color: white;
  cursor: pointer;
  transition: all 0.5s;
  font-size: 18px;
  margin-bottom: 30px;
 
}

button:hover {
  background-color: ${props => props.theme.hover};
}

h3 {
    font-size: 45px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  h4 {
    font-size: 35px;
    font-weight: 500;
  }

 h1 {
    font-size: 25px;
    margin-bottom: 20px;
  }


@media screen and (max-width: 720px) {
  padding: 50px;
  button {
  font-size: 16px;
    padding: 5px;
    padding: 10px;
  }

 h2 {
    font-size: 45px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  h3 {
    font-size: 35px;
   
  }

 h1 {
    font-size: 25px;
 
  }

  }



  @media screen and (max-width: 525px) {
  
  
    padding: 50px;
 

 h3 {
    font-size: 35px;
    margin-bottom: 10px;
    
  }

h4 {
    font-size: 30px;
    font-weight: 500;
  }

 h1 {
    font-size: 25px;
    font-weight: 100;
  }

 button {
    font-size: 14px;
    padding: 10px;
  }
  }

  @media screen and (max-height: 520px){

 
button{
  display: none;
}

  }






  @media screen and (max-width: 430px) {

    padding: 30px;

    h3 {
    font-size: 28px;

  }

h4 {
    font-size: 25px;
   
  }

 h1 {
    font-size: 20px;
  
  }
  }

  


@media screen and (max-width: 370px) {

  h3 {
font-size: 22px;

}

h4 {
font-size: 22px;

}

h1 {
font-size: 18px;

}
}

`

